import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import PageHeader from "@/components/PageHeader";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Users, Activity, Megaphone, Link2, Archive, Globe } from "lucide-react";
import { StaffArchive } from "@/components/StaffArchive";
import { NeedsAttention } from "@/components/NeedsAttention";
import { TimeTodayTile } from "@/components/admin/TimeTodayTile";
import { AuditLog } from "@/components/admin/AuditLog";
import { AlertsTab } from "@/components/admin/AlertsTab";
import { QuickLinksTab } from "@/components/admin/QuickLinksTab";
import { UsersTab } from "@/components/admin/UsersTab";
import { NetworkAccessTab } from "@/components/admin/NetworkAccessTab";

export default function Admin() {
  const { user } = useAuth();
  if (user?.role !== "admin") return <Navigate to="/" replace />;

  return (
    <div data-testid="admin-page">
      <PageHeader overline="Restricted" title="Administration" subtitle="Manage users, quick links and monitor the DLP activity audit trail." />

      <Tabs defaultValue="audit">
        <TabsList className="mb-6">
          <TabsTrigger value="audit" data-testid="tab-audit"><Activity className="h-4 w-4 mr-1.5" /> Audit Log (DLP)</TabsTrigger>
          <TabsTrigger value="alerts" data-testid="tab-alerts"><Megaphone className="h-4 w-4 mr-1.5" /> Alerts</TabsTrigger>
          <TabsTrigger value="links" data-testid="tab-links"><Link2 className="h-4 w-4 mr-1.5" /> Quick Links</TabsTrigger>
          <TabsTrigger value="users" data-testid="tab-users"><Users className="h-4 w-4 mr-1.5" /> Users</TabsTrigger>
          <TabsTrigger value="archive" data-testid="tab-archive"><Archive className="h-4 w-4 mr-1.5" /> Staff Archive</TabsTrigger>
          <TabsTrigger value="network" data-testid="tab-network"><Globe className="h-4 w-4 mr-1.5" /> Network Access</TabsTrigger>
        </TabsList>

        <TabsContent value="audit">
          <NeedsAttention className="mb-6" />
          <TimeTodayTile />
          <AuditLog />
        </TabsContent>
        <TabsContent value="alerts"><AlertsTab /></TabsContent>
        <TabsContent value="links"><QuickLinksTab /></TabsContent>
        <TabsContent value="users"><UsersTab /></TabsContent>
        <TabsContent value="archive"><StaffArchive /></TabsContent>
        <TabsContent value="network"><NetworkAccessTab /></TabsContent>
      </Tabs>
    </div>
  );
}
